import { useTranslation } from 'react-i18next';
import { cn, FormatUtils } from '@shared/utils';
import { AccountStatus, type AccountResponse } from '@shared/api';
import { Icon, Text } from '@shared/widgets';
import CardIcon from '@assets/icons/card.svg';

interface AccountDetailsProps {
  className?: string;
  account: AccountResponse;
  isVcfc?: boolean;
}

export const AccountDetails = (props: AccountDetailsProps) => {
  const { t } = useTranslation('accounts');

  return (
    <ul className={cn('flex flex-col gap-2', props.className)}>
      <li className='flex justify-between'>
        <Text size='sm' color={props.isVcfc ? (props.account.status === AccountStatus.Active ? 'white' : 'black') : 'secondary'}>
          {t('card.tile.fields.accountNumber')}
        </Text>
        <Text weight='medium' size='xs' color={props.isVcfc ? (props.account.status === AccountStatus.Active ? 'white' : 'black') : undefined}>
          {FormatUtils.toSliceNumber(props.account.accountNumber)}
        </Text>
      </li>
      <li className='flex justify-between'>
        <Text size='sm' color={props.isVcfc ? (props.account.status === AccountStatus.Active ? 'white' : 'black') : 'secondary'}>
          {t('card.tile.fields.cards')}
        </Text>
        <div className='flex items-center gap-1'>
          <Text weight='medium' size='xs' color={props.isVcfc ? (props.account.status === AccountStatus.Active ? 'white' : 'black') : undefined}>
            {props.account.cardsCount}
          </Text>
          <Icon
            icon={
              <CardIcon
                className={cn(props.isVcfc && props.account.status === AccountStatus.Active ? 'text-white' : 'text-soft-black')}
                width='16'
                height='16'
              />
            }
          />
        </div>
      </li>
    </ul>
  );
};
